import clipboardCopy from 'clipboard-copy';

import type { SnackbarFn } from '@/hooks/useSnackbar';

export const copyToClipboard = async (
  text: string,
  enqueueSnackbar: SnackbarFn,
  {
    successMessage = 'Copied link to clipboard!',
    errorMessage = 'There was an error copying the link',
  }: {
    successMessage?: string;
    errorMessage?: string;
  } = {},
) => {
  try {
    await clipboardCopy(text);
    enqueueSnackbar(successMessage);
  } catch (err) {
    if (err instanceof Error) {
      enqueueSnackbar(`${errorMessage} - ${err.message}`, {
        variant: 'error',
      });
    }
  }
};
